import * as types from '../constants/ScheduleActionTypes';
import fetch from 'isomorphic-fetch'
import {__PREFIX__} from '../constants/UrlPrefix'
import {fetch_lotteries, select_lottery} from './LotteryActions';
//import {fetch_channels, select_channel} from './ChannelActions';

/*export function fetch_schedule(scheduleId, start, end) {
	return function(dispatch){
		dispatch(request_schedule(scheduleId));
		
        dispatch(receive_schedule(scheduleId, {data: []}));

	}
}

export function request_schedule(scheduleId) {  
  return {
    type: types.REQUEST_SCHEDULE,
    scheduleId: scheduleId
  };
}

export function receive_schedule(scheduleId, json){
	return  {
		type: types.RECEIVE_SCHEDULE,
		schedule: json.data,
		scheduleId: scheduleId
	}
}*/

export function set_timespan(scheduleId, start, end, fetch_schedule){
	return function(dispatch){

		dispatch(start_change_timespan(scheduleId));
				
		return (new Promise((resolve, reject) => {				
				(async () => {
					//await fetch_channels()(dispatch);
					//await fetch_lotteries()(dispatch);

        console.log('ScheduleId', scheduleId);
                    let fetchFunction = fetch_schedule(scheduleId, start, end);
					await fetchFunction(dispatch);
					//dispatch(set_timespan(scheduleId, start, end));
					dispatch(end_change_timespan(scheduleId, start, end));
					resolve();
				})();
			}));
	}	
}

export function set_filter(scheduleId, channelId, lotteryId){
	return function(dispatch){
		dispatch(select_lottery(lotteryId));
		dispatch(select_channel(channelId));
		dispatch(update_filter(scheduleId, channelId, lotteryId));
	}	
}

export function update_filter(scheduleId, channelId, lotteryId){
	return {
		type: types.UPDATE_FILTER,
		scheduleId: scheduleId,
		lotteryId: lotteryId,
		channelId: channelId
	}
}

/*export function save_schedule(scheduleId, start, end, lottery, channel, data) {
	return function(dispatch){
		dispatch(request_save_schedule(scheduleId));
		
		var request = new Request('' + __PREFIX__ + 'Schedules/' + scheduleId + '/' + start + '/' + end + '.json?lotteryId=' + lottery + '&channelId=' + channel, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'PUT', 
			body: JSON.stringify({
				data: {
					schedule: data
				}
			}),
			credentials: 'include'
		});
		
		return fetch(request)
			.then(response => response.json())
			.then(json => {
				dispatch(receive_save_schedule(scheduleId, json));
			})
	}
}

export function request_save_schedule(scheduleId) {  
  return {
    type: types.REQUEST_SAVE_SCHEDULE,
    scheduleId: scheduleId
  };
}

export function receive_save_schedule(scheduleId, json){
	return  {
		type: types.RECEIVE_SAVE_SCHEDULE,
		schedule: json.data,
		scheduleId: scheduleId,
		schedule: json.data
	}
}*/

export function start_change_timespan(scheduleId){
	return {
		type: types.START_CHANGE_TIMESPAN,
		scheduleId: scheduleId
	}
}

export function end_change_timespan(scheduleId, start, end){
	return {
		type: types.END_CHANGE_TIMESPAN,
		scheduleId: scheduleId,
		start: start,
		end: end
	};
}

export function set_drag_position(scheduleId, timestamp, trackIdx){
	return {
		type: types.SET_DRAG_POSITION,
		scheduleId: scheduleId,
		timestamp: timestamp,
		trackIdx: trackIdx
	};
}

export function drag_start(scheduleId, action, trackIdx, itemIdx, params){
	return {
		type: types.DRAG_START,
		scheduleId: scheduleId,
		action: action,
		trackIdx: trackIdx,
		itemIdx: itemIdx,
		params: params
	}
}

export function drag_end(scheduleId){
	return {
		type: types.DRAG_END,
		scheduleId: scheduleId
	}
}

export function start_create(scheduleId, timestamp, trackIdx, meta){
	return {
		type: types.START_CREATE,
		scheduleId: scheduleId,
		timestamp: timestamp,
		trackIdx: trackIdx,
		meta: meta
	}
}

export function end_create(scheduleId, timestamp, trackIdx){
	return {
		type: types.END_CREATE,
		scheduleId: scheduleId,
		timestamp: timestamp,
		trackIdx: trackIdx
	}
}

export function select_item(scheduleId, itemIdx, trackIdx){
	return {
		type: types.SELECT_ITEM,
		scheduleId: scheduleId,
		trackIdx: trackIdx,
		itemIdx: itemIdx
	}
}

export function add_track(scheduleId){
	return {
		type: types.ADD_TRACK,
		scheduleId: scheduleId
	}
}

export function remove_item(scheduleId, itemIdx, trackIdx){
	return {
		type: types.REMOVE_ITEM,
		scheduleId: scheduleId,
		trackIdx: trackIdx,
		itemIdx: itemIdx
	}
}